import { MEDIA_URL } from "@/services/api";
import Image from "next/image";
import Link from "next/link";
import { localePrefix } from "@/helper/helper";

interface Props {
  thumbnail: string;
  name: string;
  slug: string;
  locale: string;
  createdAt: string;
}

export default function BlogCard({
  thumbnail,
  name,
  slug,
  locale,
  createdAt,
}: Props) {
  return (
    <Link
      href={`${localePrefix(locale)}/blog/${slug}`}
      target={"_blank"}
      className="blog-card"
    >
      <Image width={600} height={366} src={`${thumbnail}`} alt="" />
      <div className="blog-card-title">{name}</div>

      <div className="blog-card-bottom">
        <span>{createdAt}</span>
      </div>
    </Link>
  );
}
